import { DataModel } from 'common/models/utility-models/base-model';

export class ApplicantFilterModel extends DataModel {
  selectedRegion: string = '';
  selectedState: string = '';
  department: string = '';
  allGenders: string = '';
  search: string = '';
  status: string = '';
  firstName: string = '';
  gender: any;
  middleName: string = '';
  age: string = '';
  lastName: string = '';
  landlineNumber: string = '';
  mobileNumber: string = '';
  email: string = '';
  city: string = '';
  alternativeEmail: string = '';
  stateId: string = '';
  district: string = '';
  district_id:string='';
  familyAnnualIncome:string='';
  fatherName: string = '';
   motherName: string = '';
  fatherProfession: string = '';
  motherProfession: string = '';
  score10: string = '';
  score12: string = '';
  physicsMarks: string = '';
  chemistryMarks: string = '';
  mathematicsMarks: string = '';
  jeeScore: string = '';
  instituteName: string = '';
  instituteContact: string = '';
  instituteAddress: string = '';
  collageStateId: string = '';
  branchId: string = '';
  firstYearFees: string = '';
  anyScholarshipName: string = '';
  anyScholarship: string = '';
  offeringInstitute: string = '';
  scholarshipAmount: string = '';
  //selectcallStatus:any='';
  callCount:any='';
  callStatus:string='';
  callRemark:string='';
  applicationId:string='';
  callCountOld:string='';
  instituteType:any='';
}



export class DepartmentListModel extends DataModel {
  override id: any = 0;
  department_name: any = " ";
  branchCategoryId: any = "";
  branchCatName: any = "";
 
}

export class EditApplicantStatus extends DataModel {
  applicant_id:any=''
}


export class rejectApplicant
{
  
    id: number = 0;
    callCountOld:number = 1;
    callFlag:number= 1;
    callRemark:string = ""

}

export class cardFilterNew
{
    region: "";
    state_id:number=0 ;
    branch_id:number=0;
    status:number=0;
    gender:"";
}